import { atom } from 'recoil';
import { EntityTranslation } from '../../domain/EntityTranslation';

export const entityTranslationsState = atom<EntityTranslation[]>({
  key: 'entityTranslationsState',
  default: [],
});
